import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { PageHeader } from "@/shared/components/PageHeader";
import { TaskTypeFormModal } from "../components/TaskTypeFormModal";
import { TaskTypeTable } from "../components/TaskTypeTable";
import { useTaskTypesStore } from "../store/task-types.store";

export function TaskTypesPage() {
	const openCreateModal = useTaskTypesStore((s) => s.openCreateModal);

	return (
		<div>
			<PageHeader
				title="Topshiriq turlari"
				action={
					<Button
						type="primary"
						icon={<PlusOutlined />}
						onClick={openCreateModal}
						id="task-types-create-btn"
					>
						Qo&apos;shish
					</Button>
				}
			/>
			<TaskTypeTable />
			<TaskTypeFormModal />
		</div>
	);
}
